import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReportViewer {
    loading: boolean;
    reportFileName: string;
    data: any;
}
const win: any = window;
const Stimulsoft = win.Stimulsoft;

interface INameToValueMap {
    [key: string]: any;
}

export class ReportViewerData extends React.Component<RouteComponentProps<{}>, ReportViewer> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            reportFileName: "",
            data: {}
        };
    }

    componentDidMount() {
        //get the name of the report
        let userParams: INameToValueMap = {};
        userParams["name"] = "";
        userParams["param1"] = "";
        userParams["param2"] = "";
        userParams["param3"] = 0;
        userParams["param4"] = 0;
        userParams["param5"] = 0;
        userParams = this.props.match.params;
        let reportName = userParams["name"];
        let param1 = userParams["param1"];
        let param2 = userParams["param2"];
        let param3 = userParams["param3"];
        let param4 = userParams["param4"];
        let param5 = userParams["param5"];

        if (reportName != "") {
            this.getData(reportName, param1, param2, param3, param4, param5);
        }
    }

    async getData(reportName: string, param1: string, param2: string, param3: number, param4: number, param5: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //get the data
        axios.get('api/Report/Get' + reportName + 'Data?param1=' + param1 + "&param2=" + param2 + "&param3=" + param3 + "&param4=" + param4 + "&param5=" + param5 + "&SubId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                this.setState({ reportFileName: res.data.reportFileName, data: res.data.reportData, loading: false });

                var options = new Stimulsoft.Viewer.StiViewerOptions();
                options.toolbar.showSendEmailButton = true;
                options.exports.showExportToCsv = false;
                options.exports.showExportToDocument = false;
                options.exports.showExportToExcel2007 = false;
                options.exports.showExportToHtml = false;
                options.exports.showExportToHtml5 = false;
                options.exports.showExportToImageSvg = false;
                options.exports.showExportToJson = false;
                options.exports.showExportToOpenDocumentCalc = false;
                options.exports.showExportToOpenDocumentWriter = false;
                options.exports.showExportToPowerPoint = false;
                options.exports.showExportToText = false;
                options.exports.showExportToWord2007 = false;

                var viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

                //console.log('Creating a new report instance');
                var report = new Stimulsoft.Report.StiReport();
                var reportFile = Stimulsoft.System.IO.File.getFile("reports/" + res.data.reportFileName);
                report.load(reportFile);

                var reportData = JSON.stringify(res.data.reportData);
                //Dataset created
                var dataSet = new Stimulsoft.System.Data.DataSet("data");
                dataSet.readJson(reportData)
                report.regData(dataSet.dataSetName, "", dataSet);
                report.reportName = res.data.reportName;
                report.dictionary.connect(false);
                report.dictionary.synchronize();

                //add relationships between data
                for (var i = 0; i < res.data.reportRelationships.length; i++) {
                    var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(res.data.reportRelationships[i].sourceName, res.data.reportRelationships[i].name, res.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(res.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(res.data.reportRelationships[i].childTableName), [res.data.reportRelationships[i].parentFieldName], [res.data.reportRelationships[i].childFieldName]);
                    report.dictionary.relations.add(dataRelation);
                    report.dictionary.synchronize();
                }

                viewer.report = report;
                viewer.onEmailReport = this.onEmailReport;
                viewer.renderHtml('viewer');
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    onEmailReport = async function (args: any) {
        // args.settings -  send email form
        // args.settings.email  -  email adress
        // args.settings.subject  -  email subject
        // args.settings.message  -  email message
        // args.formatName  -  export format - PDF, HTML, HTML 5, Excel2007, Word2007, CSV
        // args.fileName - report file name (name of attachement)
        // args.data  -  byte array with exported report file

        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var fileData = [new Uint8Array(args.data)];
        var reportFile = new File(fileData, args.fileName, { type: 'application/pdf' });

        const data = new FormData()
        data.append('emailTo', args.settings.email);
        data.append('subject', args.settings.subject);
        data.append('message', args.settings.message);
        data.append('subId', user.sub);
        data.append('report', reportFile);

        //send report in an email
        axios.post('api/Report/EmailReport', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Report has been emailed");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    arrayBufferToBase64 = (buffer: any) => {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div id="viewer"></div>
        )
    }

}
